import { ShareIcon } from "@heroicons/react/24/solid";
import { useParams } from "@tanstack/react-router";
import { useNavigate } from "@tanstack/react-router";
import { useSnackbar } from "notistack";
import { useEffect, useRef } from "react";
import { socialPost } from "app/router";
import { SocialCommentsWrapper } from "screens/social/comment/SocialCommentsWrapper";
import { SocialPostWrapper } from "screens/social/post/SocialPostWrapper";
import { Button, CardTitle } from "components/elements";
import { CopyShareButton } from "components/elements/CopyShareButton";
import { trpc } from "lib/trpc";
import { ClientPost } from "@compass/shared/types";

export const SocialView = () => {
    const postId = +useParams({ from: socialPost.id }).id;
    const { data: post, isInitialLoading } = trpc.social.posts.get.useQuery<ClientPost>({ postId });
    const { data: thread } = trpc.social.posts.getThread.useQuery({ postId });
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();

    // Get commentId from query string
    const searchParams = new URLSearchParams(window.location.search);
    const commentId = searchParams.get("commentId");

    useEffect(() => {
        if (!post && !isInitialLoading) {
            enqueueSnackbar("This post has been deleted or is no longer available.", {
                variant: "info",
            });
            navigate({ to: "/social" });
        }
    }, [post, isInitialLoading]);

    // Scroll to comment if commentId is provided
    useEffect(() => {
        if (post && commentId) {
            // Wait a bit for the DOM to render
            setTimeout(() => {
                const commentElement = document.getElementById(`comment-${commentId}`);
                if (commentElement) {
                    commentElement.scrollIntoView({ behavior: "smooth", block: "center" });
                    // Optional: highlight the comment briefly
                    commentElement.classList.add("ring-2", "ring-blue-500", "ring-opacity-50");
                    setTimeout(() => {
                        commentElement.classList.remove(
                            "ring-2",
                            "ring-blue-500",
                            "ring-opacity-50",
                        );
                    }, 2000);
                }
            }, 300);
        }
    }, [post, commentId]);

    if (!post || isInitialLoading) {
        return null;
    }

    return (
        <div className="flex flex-1 flex-col ">
            <CardTitle
                actions={<div className="flex items-center justify-end "></div>}
                backLinkTo="/social"
                backLinkTitle="Social"
            >
                <></>
            </CardTitle>
            <div className="card group p-4">
                <SocialPostWrapper post={post} isModalView />
                {thread && <SocialCommentsWrapper post={post} threadId={thread.id} />}
            </div>
        </div>
    );
};
